import firebase from 'firebase/app'
import 'firebase/firestore'
import Vue from 'vue'
import { Logger } from '@/js/utils/Logger.js'


export default class OrderHistoryManager {
    constructor() {
      this.orderHistory = [];
    }
    async update() {
      Logger.info("OrderHistoryManager Update")

      // 初期化
      this.orderHistory.splice(0);

      // 変数のリアクティブ化
      Vue.set(this.orderHistory);

      // カートデータを取得
      await this.getFBOrderHistoryData();

      Logger.debug(this.orderHistory);
    }

    async getFBOrderHistoryData(){
      const ref = firebase.firestore().collection("AcryProOrderHistory");
      const snapshot = await ref.where("uid", "==", firebase.auth().currentUser.uid).get();

      for( let i = 0; i<snapshot.docs.length; ++i ){
        const data = snapshot.docs[i].data();
        const obj =
          {
            uid: data.uid,
            orderId: data.orderId,
            acrylProducts: ("acrylProducts" in data)?data.acrylProducts:[],
            sampleProducts: ("sampleProducts" in data)?data.sampleProducts:[],
            optionProducts: ("optionProducts" in data)?data.optionProducts:[],
            ticketProducts: ("ticketProducts" in data)?data.ticketProducts:[],
            acryPrintProducts: ("acryPrintProducts" in data)?data.acryPrintProducts:[],
            acryPrintSampleProducts: ("acryPrintSampleProducts" in data)?data.acryPrintSampleProducts:[],
          };
          this.orderHistory.push(obj);
      }
      Logger.debug(this.orderHistory);
    }

    getOrderHistoryData( orderId ){
      return this.orderHistory.filter((item)=>{return item.orderId == orderId})[0];
    }

    registOrderHistoryDataForTicket( orderId, ticketProducts ){
      let data =
      {
          uid: firebase.auth().currentUser.uid,
          orderId: orderId,
          acrylProducts: [],
          sampleProducts: [],
          optionProducts: [],
          ticketProducts: [],
          acryPrintProducts: [],
          acryPrintSampleProducts: [],
      };

      for (let i = 0; i < ticketProducts.length; ++i) {
          // オプション品
          let productData = {};
          productData.productId = ticketProducts[i].productId;
          productData.quantity = ticketProducts[i].quantity;
          productData.acrylicTicketSetting = ticketProducts[i].acrylicTicketSetting;
          productData.previewUrl = ticketProducts[i].previewUrl;
          data.ticketProducts.push(productData);
      }

      console.log(data);
      return new Promise((resolve) => {
        firebase.firestore().collection("AcryProOrderHistory").add(data).then(()=>
        {
            resolve();
        });
      })
    }

    registOrderHistoryData( orderId, products = {} )
    {
      const {
          acrylProducts = [],
          optionProducts = [],
          sampleProducts = [],
          acryPrintProducts = [],
          acryPrintSampleProducts = [],
      } = products;

      let data =
      {
          uid: firebase.auth().currentUser.uid,
          orderId: orderId,
          acrylProducts: [],
          sampleProducts: [],
          optionProducts: [],
          ticketProducts: [],
          acryPrintProducts: [],
          acryPrintSampleProducts: [],
      };

      for (let i = 0; i < acrylProducts.length; ++i) {
          // アクリル商品
          let productData = {};
          productData.productId = acrylProducts[i].productId;
          productData.designId = acrylProducts[i].id;
          productData.price = acrylProducts[i].getPrice();
          productData.quantity = acrylProducts[i].quantity;
          productData.designImageUrl = acrylProducts[i].designFilePath;
          productData.cutlineImageUrl = acrylProducts[i].cutlineFilePath;
          productData.previewImageUrl = acrylProducts[i].previewFilePath;
          productData.acrylImageUrls = [];
          for( let j=0; j<acrylProducts[i].acrylFile.length; ++j ){
              productData.acrylImageUrls.push(acrylProducts[i].acrylFile[j].design);
          }
          data.acrylProducts.push(productData);
      }

      for (let i = 0; i < sampleProducts.length; ++i) {
        // アクリル商品
        let productData = {};
        productData.productId = sampleProducts[i].productId;
        productData.designId = sampleProducts[i].id;
        productData.price = sampleProducts[i].getPrice();
        productData.quantity = sampleProducts[i].quantity;
        productData.designImageUrl = sampleProducts[i].designFilePath;
        productData.cutlineImageUrl = sampleProducts[i].cutlineFilePath;
        productData.previewImageUrl = sampleProducts[i].previewFilePath;
        productData.acrylImageUrls = [];
        for( let j=0; j<sampleProducts[i].acrylFile.length; ++j ){
            productData.acrylImageUrls.push(sampleProducts[i].acrylFile[j].design);
        }
        data.sampleProducts.push(productData);
      }

      for (let i = 0; i < optionProducts.length; ++i) {
          // オプション品
          let productData = {};
          productData.productId = optionProducts[i].productId;
          productData.price = optionProducts[i].price;
          productData.quantity = optionProducts[i].quantity;
          productData.designImageUrl = optionProducts[i].designFilePath;
          productData.name = optionProducts[i].name;
          data.optionProducts.push(productData);
      }

     for (let i = 0; i < acryPrintProducts.length; ++i) {
          // ACRYPRINT
          let productData = {};
          productData.productId = acryPrintProducts[i].productId;
          productData.designId = acryPrintProducts[i].id;
          productData.price = acryPrintProducts[i].getPrice();
          productData.quantity = acryPrintProducts[i].quantity;
          productData.designImageUrl = acryPrintProducts[i].designFilePath;
          productData.cutlineImageUrl = acryPrintProducts[i].cutlineFilePath;
          productData.previewImageUrl = acryPrintProducts[i].previewFilePath;
          productData.acrylImageUrls = [];
          for( let j=0; j<acryPrintProducts[i].acrylFile.length; ++j ){
              productData.acrylImageUrls.push(acryPrintProducts[i].acrylFile[j].design);
          }
          data.acryPrintProducts.push(productData);
      }

     for (let i = 0; i < acryPrintSampleProducts.length; ++i) {
          // ACRYPRINT
          let productData = {};
          productData.productId = acryPrintSampleProducts[i].productId;
          productData.designId = acryPrintSampleProducts[i].id;
          productData.price = acryPrintSampleProducts[i].getPrice();
          productData.quantity = acryPrintSampleProducts[i].quantity;
          productData.designImageUrl = acryPrintSampleProducts[i].designFilePath;
          productData.cutlineImageUrl = acryPrintSampleProducts[i].cutlineFilePath;
          productData.previewImageUrl = acryPrintSampleProducts[i].previewFilePath;
          productData.acrylImageUrls = [];
          for( let j=0; j<acryPrintSampleProducts[i].acrylFile.length; ++j ){
              productData.acrylImageUrls.push(acryPrintSampleProducts[i].acrylFile[j].design);
          }
          data.acryPrintSampleProducts.push(productData);
      }

      return new Promise((resolve) => {
        firebase.firestore().collection("AcryProOrderHistory").add(data).then(()=>
        {
            resolve();
        });
      })
    }
}
export { OrderHistoryManager }